module.exports = __webpack_public_path__ + "static/media/c50-connect.e3f1fec7.png";